import React from "react";
import styled from "styled-components";
import {isMobile} from 'react-device-detect';
import { Link } from "react-router-dom";

import Container from "./container"
import Buttons from "./buttons"

import mam from "../images/mam.png"
import mamSmall from "../images/mam_small.png"
import TicketsButton from "./button-tickets";
import colors from "../settings/colors";

const Show = styled.section`
    display: ${isMobile ? "block":"flex"};
    align-items: flex-start;
    padding: 25px 0px;
`
const Poster = styled.div`
    flex-basis: 35%;

    img {
        width: 100%; 

        &.poster {
            border-radius: 3px;
        }
    }
`
const Info = styled.div`
    flex-basis: 65%;
    padding-left: ${isMobile ? 0:15}px;
    font-size: 22px;
    line-height: ${isMobile ? 1.2:1.6}em;

    h3 {
        margin-top: ${isMobile ? 15:0}px;
        text-transform: uppercase;
        font-size: 40px;
        font-weight: bold;
        text-align: ${isMobile ? "center":"left"};
        line-height: 1em;

        a {
            text-decoration: none;
            color: white;

            &:hover {
                text-decoration: underline;
            }
        }
        small {
            display: block;
            color: #999;
            margin-top: ${isMobile ? 15:0}px;
            line-height: 1em;
            font-size: 70%;
        }
    }

    p small {
        line-height: normal;
    }

    strong {
        color: ${colors.orange};
    }

    div.specialEvent {
        margin-top: ${isMobile ? 20:0}px;
        text-align: ${isMobile ? "center":"left"};

        span {
            background-color: ${colors.green};
            color: white;
            font-weight: bold;
            padding: 3px 15px;
            display: inline-block;
            margin-bottom: 10px;            
        }
    }    
`

function ShowPreview({show, masters}) {
  return (
    <Container>
        <Show>
            <Poster>
                <Link to={show.url}>
                    <img src={show.poster} alt={show.title + " Poster"} width={200} className="poster" />
                </Link>

                {show.posterInfo && 
                    <div style={{marginTop: "10px"}}>
                        {show.posterInfo}                        
                    </div>
                }

                {show.mastersAtMarshall &&
                    <div style={{marginTop: "10px"}}>
                        <img src={masters ? mam : mamSmall} alt="Masters At Marshall" />

                        <div style={{marginTop: "6px", display: "flex", alignItems: "center", justifyContent: "space-between"}}>
                            <small>Packages to the speaker series are available</small>
                            <TicketsButton small show={{
                                tickets: show.mastersAtMarshallTickets
                            }} />
                        </div>                        
                    </div>
                }
            </Poster>
            <Info>
                {show.specialEvent && 
                    <div className="specialEvent">
                        <span>
                            Special Event
                        </span>
                    </div>
                }

                <h3>
                    <Link to={show.url}>
                        {show.title}
                    </Link>
                    {show.subtitle && <small>{show.subtitle}</small>}
                </h3>

                <div className="date">{show.dateFormatted}</div>
                {show.timeFormatted && <div className="time">{show.timeFormatted}</div>}
                {show.location && 
                    <div className="location">
                        {show.location}

                        {(show.location == "Joan C. Edwards Performing Arts Center") &&
                            <div style={{
                                marginTop: "-10px",
                                color: "#999",
                            }}>
                                <small>* Parking garage located next to facility (cash only)</small>
                            </div>
                        }                             
                    </div>
                }           
                {show.description && <p><small dangerouslySetInnerHTML={{__html: show.description}} /></p>}

                <Buttons show={show} more tickets />
            </Info>
        </Show>
    </Container>    
  );
}

export default ShowPreview;